import { render, staticRenderFns } from "./CustomerImportSuccess.vue?vue&type=template&id=22629f22&scoped=true&"
import script from "./CustomerImportSuccess.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportSuccess.vue?vue&type=style&index=0&id=22629f22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22629f22",
  null
  
)

export default component.exports